import script from "./Editbox.vue?vue&type=script&setup=true&lang=js"
export * from "./Editbox.vue?vue&type=script&setup=true&lang=js"

import "./Editbox.vue?vue&type=style&index=0&id=1b573aca&scoped=true&lang=css"

import exportComponent from "/home/runner/work/cube-viewer/cube-viewer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b573aca"]])

export default __exports__